import { useEffect } from 'react';

import { SHORTCUT_CONST } from '@/constant';
import { useShortcut } from '@/package';
import { useToolMenuStore } from '@/store';

export const useToolShortcutRegister = () => {
  const { namespace, register, unregister } = useShortcut();

  useEffect(() => {
    if (namespace !== SHORTCUT_CONST.SHORTCUT_NAMESPACE.LABELING) return;

    const findByName = useToolMenuStore.getState().findByName;
    const shouldRegisterToolMenuList = [
      /** TrackID 관련 */
      findByName('copyTrackID'),
      findByName('pasteTrackID'),
      findByName('searchTrackID'),
      findByName('updateTrackID'),
      findByName('isShortTrackID'),
      findByName('labelBoxTrackID'),

      /** Label Box 편집 관련 */
      findByName('labelBoxArrow'),
      findByName('labelBoxCopy'),
      findByName('labelBoxCut'),
      findByName('labelBoxPaste'),
      findByName('labelBoxRemove'),
      findByName('select'),
      findByName('selectAll'),
      findByName('focusPrevBox'),
      findByName('focusNextBox'),

      /** Review 관련 */
      findByName('reviewData'),

      /** Box Validation 관련 */
      findByName('boxValidation'),

      /** Shortcut 관련 */
      findByName('shortcutPopup'),

      /** Tool Menu 관련 */
      findByName('deselectAllToolMenu'),

      /** Frame Cam 관련 */
      findByName('frameCamImage'),

      /** Grid 관련 */
      findByName('grid'),

      /** Setting 관련 */
      findByName('settings'),
    ];

    shouldRegisterToolMenuList.forEach(tool => {
      if (tool && tool.command) {
        register(tool.command, () =>
          useToolMenuStore.getState().select(tool.id),
        );
      }
    });

    return () => {
      shouldRegisterToolMenuList.forEach(tool => {
        if (tool && tool.command) unregister(tool.command);
      });
    };
  }, [namespace]);
};
